import script from "./GameModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GameModal.vue?vue&type=script&setup=true&lang=js"

import "./GameModal.vue?vue&type=style&index=0&id=8463dd9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8463dd9c"]])

export default __exports__